import { learningPath } from "@/mocks/content";

export default function LearningPath() {
  return (
    <section id="path" className="w-full bg-background-50 py-16 md:py-24">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-8">
        <div className="max-w-3xl">
          <span className="text-xs md:text-sm font-label font-medium tracking-widest text-accent-700 uppercase">
            Learning path
          </span>
          <h2 className="mt-3 font-heading font-bold text-2xl md:text-4xl text-foreground-950 leading-snug">
            学习路径：五步走完整个系列
          </h2>
          <p className="mt-4 text-sm md:text-base leading-relaxed text-foreground-700 font-body">
            如果你打算系统地把系列学一遍，可以按下面的顺序推进。每一步都标出了重点与大致用时，
            不必严格卡时间，按自己的节奏来就好。
          </p>
        </div>

        <ol className="mt-10 relative">
          <span
            className="hidden md:block absolute left-[19px] top-2 bottom-2 w-px bg-background-300/70"
            aria-hidden="true"
          ></span>
          {learningPath.map((step) => (
            <li key={step.id} className="relative flex gap-5 md:gap-6 pb-8 last:pb-0">
              <span className="relative z-10 w-10 h-10 shrink-0 flex items-center justify-center rounded-full bg-accent-500 text-background-50 dark:text-foreground-950 font-heading font-bold text-sm">
                {step.phase.replace("第", "").replace("步", "")}
              </span>

              <div className="flex-1 rounded-lg bg-background-100 border border-background-200/70 p-5">
                <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2">
                  <h3 className="font-heading font-semibold text-base md:text-lg text-foreground-950">
                    {step.title}
                  </h3>
                  <span className="text-xs md:text-sm text-foreground-600 font-label whitespace-nowrap">
                    {step.range}
                  </span>
                </div>
                <p className="mt-3 text-sm leading-relaxed text-foreground-700 font-body">
                  {step.description}
                </p>
                <div className="mt-3 flex flex-wrap gap-1.5">
                  {step.focus.map((item) => (
                    <span
                      key={item}
                      className="px-2.5 py-1 rounded-full bg-secondary-100 text-secondary-900 text-xs font-label"
                    >
                      {item}
                    </span>
                  ))}
                </div>
              </div>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
}